/* eslint-disable react/prop-types */
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers"
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react"
import { Grid } from "@material-ui/core"
import { useForm } from "react-hook-form"
import { has } from "lodash"
import StandardTextField from "components/common/input/StandardTextField"
import useCurrentUser from "utils/auth/useCurrentUser"
import { purgeInitialFormData } from "utils/form-data"
import { USER_BLANK_FORMS } from "./const"

const schema = yup.object().shape({
  madeBy: yup.string().required("This field is required"),
})

const ReceiptOfInvoiceUserForm = forwardRef(({ initialValue = {} }, ref) => {
  const currUser = useCurrentUser()

  const [formData, setFormData] = useState(() =>
    purgeInitialFormData(initialValue || {}, USER_BLANK_FORMS)
  )

  const { register, handleSubmit, errors, getValues, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: formData,
  })

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      const currentFormData = getValues()
      const data = { ...formData, ...currentFormData }
      return data
    },
    submitForm: () =>
      new Promise((res, rej) => {
        handleSubmit(res, rej)()
      }),
  }))

  const handleChange = (event) => {
    const { name, value } = event.target
    if (has(formData, name)) {
      const newFormData = { ...formData, [name]: value }
      setFormData(newFormData)
    }
  }

  const settings = {
    onChange: handleChange,
    fullWidth: true,
    margin: "dense",
  }

  // 🔑 Ini bagian penting: sama persis pola WOGeneralForm
  useEffect(() => {
    if (!formData.madeBy && currUser && currUser.name) {
      setValue("madeBy", currUser.name ?? "")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currUser])

  return (
    <Grid item xs={12} md={6}>
      <StandardTextField
        label="Dibuat Oleh"
        {...settings}
        name="madeBy"
        inputRef={register({ required: "This field is required" })}
        error={!!errors.madeBy}
        helperText={errors?.madeBy?.message}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>
  )
})

export default ReceiptOfInvoiceUserForm
